import { getCurrentUser } from '@creditsights/api-ui-web';
import { COMPANY_WIDGETS_KEY } from '../../pages/Company/Company.constants';
import { DEFAULT_COMPANY_WIDGETS_ORDER_CONFIG } from '../../pages/Company/CompanyOverviewTab/CompanyOverviewTab.constants';
import { useOnDragResult } from '../common/useOnDrag';
import useFetchUserPermissions from '../permissions/useFetchUserPermissions';
import { useOnDragCompany } from './index';
import { CompanyDraggableState } from './useOnDragCompany';

const useOnDragOverview = (columnView: number): useOnDragResult<CompanyDraggableState> => {
  const { userId } = getCurrentUser();
  const { data: userPermissions } = useFetchUserPermissions();
  const companyWidgetsKey = `${COMPANY_WIDGETS_KEY}_${columnView}_${userId}`;
  const defaultConfig = DEFAULT_COMPANY_WIDGETS_ORDER_CONFIG[userPermissions!.userSubscription];

  return useOnDragCompany(columnView, companyWidgetsKey, defaultConfig);
};

export default useOnDragOverview;
